<div fxLayout="row" fxLayoutAlign="start center" *ngIf="displayValidToHint">
    <mat-icon [matTooltip]="'OVERVIEW.TABLE.VALIDATION_RUN_OUT.TOOLTIP' | translate: { days: validUntilDays }">
        error
    </mat-icon>
    <span>{{ 'OVERVIEW.TABLE.VALIDATION_RUN_OUT.TOOLTIP' | translate: { days: validUntilDays } }}</span>
</div>
